<template>
  <div class="g-info">
    <Poptip trigger="hover" placement="left" style="width:100%;height:50%;">
      <div class="g-info-box" style="border-bottom:1px solid #fff;padding:6px 0 5px;">
        <i style="font-size:34px;margin-top:-5px;" class="icon iconfont icon-weixin11"></i>
        <span style="margin-top: -10px;">微信</span>
      </div>
      <div slot="content">
        <img style="width:116px;height:116px;border-radius:5px;" src="@assets/img/cmef-wx.png" />
      </div>
    </Poptip>
    <Poptip trigger="hover" placement="left" style="width:100%;height:50%;" popper-class="pop-ly">
      <div class="g-info-box" style="padding-top:5px;">
        <i style="font-size:34px;margin-top:-5px;" class="icon iconfont icon-lingying1"></i>
        <span style="margin-top: -10px;">领英</span>
      </div>
      <div slot="content">
        <img style="width:106px;height:105px;border-radius:5px;" src="@assets/img/cmef-ly.png" />
      </div>
    </Poptip>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "g-info",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      exhibitionId:'getExhibitionId',
    })
  },
  created() {
  },
  methods: {
    ...mapMutations({
      setCaId: "exhibitor/setCaId"
    }),
    ...mapActions({
    }),
  },
};
</script>

<style lang="scss" scoped>
.g-info {
  position: fixed;
  right: 0;
  top: 500px;
  z-index: 100;
  width: 60px;
  height: 140px;
  background-color: #00bdca;
  cursor: pointer;
  color: #fff;
  padding: 0 10px;
  font-size: 12px;
  &-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  /deep/ .ivu-poptip-rel {
    width: 100%;
    height: 100%;
  }
  /deep/ .ivu-poptip-popper {
    min-width: auto;
    left: -140px !important;
    .ivu-poptip-body {
      padding: 0;
      height: 116px;
    }
    .ivu-poptip-content {
    	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
    }
    .ivu-poptip-inner {
      height: 116px;
      border-radius: 5px;
    }
  }
}
/deep/ .pop-ly {
  .ivu-poptip-body {
    padding: 5px !important;
  }
  .ivu-poptip-inner {
    height: 116px !important;
  }
}
</style>